import { render, staticRenderFns } from "./ZeigeAmazonLaender.vue?vue&type=template&id=4613050a&"
import script from "./ZeigeAmazonLaender.vue?vue&type=script&lang=js&"
export * from "./ZeigeAmazonLaender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports